export const sanitaryWareCategories = [
  {
    id: 1,
    name: "Toilets & WC",
    description:
      "Modern toilet systems with dual flush technology and space-efficient designs for contemporary bathrooms.",
    keyCharacteristics: [
      "Dual flush system",
      "Water saving technology",
      "Soft closing seat",
      "Easy installation",
    ],
    commonMaterials: [
      "Vitreous china",
      "Ceramic",
      "Plastic components",
      "Metal fittings",
    ],
    primaryUse: [
      "Residential bathrooms",
      "Commercial restrooms",
      "Hotel facilities",
      "Public washrooms",
      "Accessible bathrooms",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["White", "Ivory", "Bone", "Biscuit"],
    warranty: "10 years on ceramic, 2 years on fittings",
    specifications: {
      material: "Vitreous china with glazed finish",
      sizes: ["Standard 65cm", "Compact 60cm", "Elongated 70cm"],
      finish: ["White", "Ivory", "Bone", "Biscuit"],
      functionality: "Dual flush 3L/6L water consumption",
      installation: "Floor mounted or wall hung options",
      maintenance: "Regular cleaning with mild disinfectant",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation:
          "Wall-hung toilet with concealed tank for modern aesthetics",
        keyChecks: [
          "Wall structure capability",
          "Plumbing concealment",
          "Accessibility height",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Standard floor-mounted with efficient flush system",
        keyChecks: [
          "Space optimization",
          "Easy maintenance",
          "Guest-friendly operation",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Wash Basins",
    description:
      "Elegant wash basins in various styles including pedestal, wall-hung, and counter-top designs.",
    keyCharacteristics: [
      "Overflow protection",
      "Smooth glazed surface",
      "Various mounting options",
      "Designer styles",
    ],
    commonMaterials: [
      "Ceramic",
      "Porcelain",
      "Natural stone",
      "Composite materials",
    ],
    primaryUse: [
      "Bathroom vanities",
      "Powder rooms",
      "Commercial washrooms",
      "Hotel bathrooms",
      "Spa facilities",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["White", "Off-white", "Designer colors", "Natural stone"],
    warranty: "5 years on ceramic, lifetime on glaze",
    specifications: {
      material: "High-grade ceramic with protective glaze",
      sizes: ["Compact 45cm", "Standard 55cm", "Large 65cm"],
      finish: ["White", "Off-white", "Designer colors", "Natural stone"],
      functionality: "Overflow protection and efficient drainage",
      installation: "Pedestal, wall-hung, or counter-top mounting",
      maintenance: "Daily cleaning with non-abrasive cleaners",
    },
    useCases: [
      {
        location: "Luxury Bathroom",
        recommendation: "Designer vessel basin with premium faucet pairing",
        keyChecks: [
          "Counter space",
          "Faucet compatibility",
          "Design coordination",
        ],
      },
      {
        location: "Small Powder Room",
        recommendation: "Compact wall-hung basin for space efficiency",
        keyChecks: [
          "Wall mounting capability",
          "Space optimization",
          "Proportional sizing",
        ],
      },
    ],
  },
];
